module.exports = __webpack_public_path__ + "img/weapon_lab_small.4b5a4911.png";